import React from 'react'

import { Form, Col } from '_zari/core'

import { Select2SocioOtros } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

import { KeyEventUtil } from 'utils'

const TrabajadorFormGroup = ({ iError, iTouched, fIsSubmitting, iValue, values, setValues }) => {
  const onChangeSocioHandler = pickedMember => {
    values._idSocio = pickedMember.value
    values.nombreSocio = pickedMember.label

    setValues(values)

    setTimeout(() => {
      KeyEventUtil.leaveOnKeyEvent(`select-entregaARenidr-tituloViatico`)
    }, 200)
  }

  const clickClear = React.useCallback(() => {
    values._idSocio = ''
    values.nombreSocio = ''

    setValues(values)
    KeyEventUtil.leaveOnKeyEvent('select2-entregaARenidr-trabajador')
  }, [setValues, values])

  return (
    <>
      <Form.Group>
        <Form.Label text='TRABAJADOR' htmlFor='input-entregaARenidr' md={4} alignRightAt='md' />
        <Col md={8}>
          {iValue ? (
            <ClearInputGroup id='entregaARenidr' iValue={iValue} clickClear={clickClear} />
          ) : (
            <Select2SocioOtros
              disabled={fIsSubmitting}
              id='select2-entregaARenidr-trabajador'
              onChange={onChangeSocioHandler}
            />
          )}
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Col>
      </Form.Group>
    </>
  )
}

export default React.memo(TrabajadorFormGroup)
